import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from '../components/LocalizationProvider';
import { getThemePaths } from '../auth/themePaths';
import getResolvedLogoUrl from '../util/getResolvedLogoUrl';

const buildCandidateList = (paths, mode) => {
  const ordered = [];
  if (paths) {
    if (mode === 'dark') {
      if (paths.logoDark) ordered.push(paths.logoDark);
      if (paths.logoLight) ordered.push(paths.logoLight);
    } else {
      if (paths.logoLight) ordered.push(paths.logoLight);
      if (paths.logoDark) ordered.push(paths.logoDark);
    }
    if (paths.logo) ordered.push(paths.logo);
    if (paths.logoLightPublic) ordered.push(paths.logoLightPublic);
    if (paths.logoDarkPublic) ordered.push(paths.logoDarkPublic);
  }
  return ordered.filter(Boolean);
};

const useBrandReportHeader = ({ titleKey = 'reportDefaultTitle', fallbackTitle } = {}) => {
  const t = useTranslation();
  const theme = useTheme();
  const revenda = useSelector((state) => state.session?.revenda);
  const paths = useMemo(() => getThemePaths(revenda), [revenda]);
  const candidates = useMemo(
    () => buildCandidateList(paths, theme.palette.mode),
    [paths, theme.palette.mode]
  );

  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;

    if (typeof window === 'undefined') {
      setLogoUrl(null);
      return () => {
        cancelled = true;
      };
    }

    const resolveLogo = async () => {
      try {
        const resolved = await getResolvedLogoUrl(candidates.length ? candidates : undefined);
        if (!cancelled) setLogoUrl(resolved || null);
      } catch (error) {
        console.warn('useBrandReportHeader: falha ao carregar logomarca', error);
        if (!cancelled) setLogoUrl(null);
      }
    };

    resolveLogo();

    return () => {
      cancelled = true;
    };
  }, [candidates]);

  const revendaName =
    revenda?.title ||
    revenda?.name ||
    revenda?.fantasia ||
    'Sistema GPS';

  const reportTitle = fallbackTitle || t(titleKey);

  const subtitle = t('reportSubtitleTemplate', {
    company: revendaName,
    report: reportTitle,
  });

  const footer = t('reportFooterTemplate', {
    company: revendaName,
  });

  return {
    logoUrl,
    title: reportTitle,
    subtitle,
    footer,
  };
};

export default useBrandReportHeader;
